import { render, staticRenderFns } from "./suContracAction.vue?vue&type=template&id=2b9b3baa&scoped=true"
import script from "./suContracAction.vue?vue&type=script&lang=js"
export * from "./suContracAction.vue?vue&type=script&lang=js"
import style0 from "./suContracAction.vue?vue&type=style&index=0&id=2b9b3baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9b3baa",
  null
  
)

export default component.exports